import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from './language.service';
import { SessionService } from './session.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(private _session: SessionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let _headers = req.headers;
    const culture = LanguageService.getCultureLang();
    if (culture) {
      _headers = req.headers.set('Accept-Language', culture);
    }

    const token = this._session.token;
    if (token) {
      _headers = _headers.append('Authorization', `Bearer ${token}`);

      if (req.detectContentTypeHeader() == 'text/plain') {
        _headers = _headers.set('Content-Type', 'application/json');
      }

      const authReq = req.clone({ headers: _headers });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
